import { Autocomplete, Grid, IconButton, TextField, Tooltip, Typography, useMediaQuery } from '@mui/material';
import React, { useState } from 'react'
import style from "../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import globalStyles from "../../../../assets/styles/global.module.scss"; 
import { useProductStore } from '../../../../store/productStore';
import { EcomProduct } from '../../../../models/axiosModel';
import { filterProductInterface } from './product';
import { primaryColor } from '../../../../utils/colors';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import RefreshIcon from '@mui/icons-material/Refresh';
import GlobalButton from '../../../utility/globalButton/button';
import DeleteIcon from '@mui/icons-material/Delete';

interface ProductPageHeaderProps {
    filters: filterProductInterface, 
    setFilters: React.Dispatch<React.SetStateAction<filterProductInterface>>, 
    filteredProducts: EcomProduct[],
    onClickOfRefresh: () => Promise<void>, 
    downloadCSVFile: () => void, 
    setFlagFilterPopup: React.Dispatch<React.SetStateAction<boolean>>, 
    checkedProducts: EcomProduct[], 
    setCheckedProducts: React.Dispatch<React.SetStateAction<EcomProduct[]>>, 
    setShowDeleteConfirmation: React.Dispatch<React.SetStateAction<boolean>>,
} 

const ProductPageHeader: React.FC<ProductPageHeaderProps> = (props) => {

    const { filters, setFilters, filteredProducts, onClickOfRefresh, downloadCSVFile, setFlagFilterPopup, checkedProducts, setCheckedProducts, setShowDeleteConfirmation } = props;
    const eComProductData = useProductStore((state) => state.eComProductData); 
    const filteredEComProductData = useProductStore((state) => state.filteredEComProductData);
    const setFilteredEComProductData = useProductStore((state) => state.setFilteredEComProductData);

    const breakPoints = {
        flagBelow1400Screen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1400px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
        screen600to1300: useMediaQuery('(min-width: 600px) and (max-width: 1300px)'),
        mobileScreen: useMediaQuery('(min-width: 0px) and (max-width: 600px)'),
    }

    return (
        <>
            <Grid container className={`${globalStyles.spaceAlignmentCenter} ${globalStyles.alignItemCenter}`} gap={2}>
                <Grid item>
                    <Grid container gap={2} alignItems={"center"}>
                        {breakPoints.flagSmallScreen ? 
                            <>
                                <Grid item>
                                    <Typography sx={{ fontSize: breakPoints.screen600to1300 ? "15px" : "14px", fontWeight: "600" }}>Product List</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="body2">Total Products: {filteredProducts?.length ?? 0}</Typography>
                                </Grid>
                            </>
                            : 
                            <>
                                <Grid item>
                                    <Autocomplete
                                        className={`${style.contactFilterDropDowns} ${style.contactFilterAutoCompleteMargin}`}
                                        options={eComProductData ?? []}
                                        getOptionLabel={(option: EcomProduct) => option.ecom_product_name}
                                        multiple
                                        value={filters.product_name ?? []}
                                        onChange={(_: React.SyntheticEvent, value: EcomProduct[]) => {
                                            setFilters((prevState: filterProductInterface) => ({ ...prevState, product_name: value }))
                                        }}
                                        renderInput={params => {
                                            const { InputProps, ...restParams } = params;
                                            const { startAdornment, ...restInputProps } = InputProps;
                                            return (
                                                <TextField
                                                    {...restParams}
                                                    placeholder='Search by Product Name'
                                                    InputProps={{
                                                        ...restInputProps,
                                                        startAdornment: (
                                                            <div style={{
                                                                maxHeight: "79px",
                                                                overflowY: 'auto',
                                                            }}
                                                            >
                                                                {startAdornment}
                                                            </div>
                                                        ),
                                                    }}
                                                />
                                            );
                                        }}
                                    />
                                </Grid>  
                                <Grid item>
                                    <Typography variant="body2">Total Products: {filteredProducts?.length ?? 0}</Typography>
                                </Grid>
                            </>
                        }
                    </Grid>
                </Grid> 
                <Grid item>
                    <Grid container gap={1}> 
                        {checkedProducts.length > 0 &&
                            <Grid item>
                                {breakPoints.mobileScreen ?
                                    <GlobalButton
                                        buttonText={`(${checkedProducts.length})`}
                                        className='deleteButton'
                                        startIcon={<DeleteIcon sx={{ color: "white" }} />}
                                        sx={{ padding: "6px 10px !important" }}
                                        // deleteCampaignContact(selectContact);
                                        onClick={() => { setShowDeleteConfirmation(true); }}
                                    />
                                    :
                                    <GlobalButton
                                        buttonText={`Delete (${checkedProducts.length})`}
                                        className='deleteButton'
                                        sx={{ padding: "6px 20px !important" }}
                                        onClick={() => { setShowDeleteConfirmation(true); }}
                                    />
                                }
                            </Grid>
                        }
                        {breakPoints.flagSmallScreen &&
                            <Grid item>
                                <Tooltip title="Filter" placement="bottom">
                                    <IconButton
                                        className={style.headerButtonStyle}
                                        onClick={() => setFlagFilterPopup(true)}
                                    >
                                        <FilterAltOutlinedIcon sx={{ color: primaryColor }} />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        }
                        <Grid item>
                            <Tooltip title="Download" placement="bottom">
                                <IconButton
                                    className={style.headerButtonStyle}
                                    onClick={() => { downloadCSVFile() }}
                                >
                                    <DownloadIcon sx={{ color: primaryColor }} />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item>
                            <Tooltip title="Refresh" placement="bottom">
                                <IconButton
                                    className={style.headerButtonStyle}
                                    onClick={() => onClickOfRefresh()}
                                >
                                    <RefreshIcon sx={{ color: primaryColor }} />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </>
    )
}

export default ProductPageHeader
